/* eslint-disable react/display-name */

import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table';
import Pagination from 'react-js-pagination';

import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

import { Button, NativeSelect } from '@material-ui/core';
import { Link } from 'react-router-dom';

import Header from '../../../layout/Header';
import Subheader from '../../../layout/Subheader';
import Loading from '../../../components/Loading';
import { findPermission } from '../../../services/auth';

import useStyles from './style';

function GridsRender({
  findAllAncoras,
  ancoras,
  ancorasLoading,
  getStatus,
  setStatus,
  setItensPerPage,
  currentPage,
  pagination,
  itensPerPage,
  setCurrentPage
}) {
  const classes = useStyles();

  const [openModalFilter, setModalFilter] = useState(false);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
          rowStyle: rowData => ({
            backgroundColor: rowData.corFundo ? rowData.corFundo : 'auto',
            color: rowData.corFonte ? rowData.corFonte : 'auto',
          })
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(711, 'Alterar')) {
            window.location.href = window.location.origin + `/app/editar-ancora/${rowData.ancoraId}`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Razão Social',
            field: 'razaoSocial',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
              width: '250px',
            },
          },
          {
            title: 'Nome Fantasia',
            field: 'nomeFantasia',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Cnpj',
            field: 'cnpj',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(711, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={`/app/visualizar-ancora/${rowData.ancoraId}`}
                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(711, 'Alterar') && (
                  <Link
                    className={classes.buttonEdit}
                    to={`/app/editar-ancora/${rowData.ancoraId}`}
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={ancoras}
      />
    ),
    [ancoras],
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    findAllAncoras(pageNumber);
  };

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title="Redes" back="/app/home" />
      <div className={classes.content}>
        <div className={classes.tableRoot} style={{ marginLeft: '5%', width: '90%' }}>
          {ancorasLoading ? (
            <Loading />
          ) : (
            <>
              <div className={classes.actions}>
                <Button
                  variant="contained"
                  onClick={() => setModalFilter(!openModalFilter)}
                  className={classes.button}
                >
                  <span>Filtros</span>
                </Button>
                {!!findPermission(711, 'Cadastrar') && (
                  <Link className={classes.button} to="/app/ancoras/cadastrar">
                    Novo Item
                  </Link>
                )}
                {openModalFilter && (
                  <div className={classes.filtersBox}>
                    <div className={classes.headFilter}>
                      <span className={classes.labelFilter}>Status:</span>
                      <button
                        className={classes.buttonClose}
                        onClick={() => setModalFilter(!openModalFilter)}
                      >
                        <CloseIcon style={{ fontSize: 25, color: '#fff' }} />
                      </button>
                    </div>
                    <select
                      onChange={(event) => setStatus(event.target.value)}
                      value={getStatus}
                      className={classes.selectStatus}
                    >
                      <option value="">Todos</option>
                      <option value="Ativo">Ativo</option>
                      <option value="Inativo">Inativo</option>
                      <option value="Pendente">Pendente</option>
                    </select>
                    <button className={classes.buttonFilter} onClick={() => findAllAncoras()}>
                      Aplicar Filtro
                    </button>
                  </div>
                )}
              </div>
              {memoizedTable}
              <div className="footer-table">
                <Pagination
                  activePage={currentPage}
                  itemsCountPerPage={itensPerPage}
                  totalItemsCount={pagination.qtdTotalRegistros}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
                <div className="select-page">
                  <label>Qtd. por página</label>
                  <NativeSelect
                    onChange={(e) => setItensPerPage(Number(e.currentTarget.value))}
                    value={itensPerPage}
                  >
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="200">200</option>
                  </NativeSelect>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default GridsRender;
